class DataLink {
	constructor() {
		const that = this;
		this.items = $('[data-link], a:not(.no-link, .ab-item)');
		this.items.on('click auxclick', function (e) {
			const url = $(this).attr('href') || $(this).data('link');
			const target = $(this).attr('target');
			const link = document.createElement('a');
			link.href = url;

			e.preventDefault();
			e.stopPropagation();

			if (e.ctrlKey || e.shiftKey || e.metaKey || (e.button && e.button === 1)) {
				link.target = '_blank';

			} else if (target) {
				link.target = target;
			}

			if (link.target) {
				link.click();
				link.remove();
			} else {
				if (pageTransitionEnabled) {
					pageTransition.leave(function () {
						that.navigate(link);
					});
				} else {
					that.navigate(link);
				}
			}

			return false;
		});
	}

	navigate() {
		document.body.appendChild(link);
		link.click();
		link.remove();
	}
}
